<template>
  <div>
    <WrapperDocRef :title="$t('message.refdocs')">
      <template
        v-if="payslip.status == 'approved'"
        #content
      >
        <BaseSectionDocRefLink
          :title="`${$t('sidebar.paymententry')} (${payslip.payments.length})`"
          :links="PELinks"
          :createButtonText="$t('newdocuments.pe')"
          :showCreateButton="getDebtPayslipAmount(payslip) > 0 && !disabled"
          @onCreate="handleClickCreatePE"
        />
      </template>
      <template
        v-else
        #content
      >
        -
      </template>
    </WrapperDocRef>

    <div
      id="registerpaymentModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="col row no-padding no-margin">
              <div class="col-6 no-padding">
                <h5 class="modal-title">{{ $t('sidebar.paymententry') }}</h5>
              </div>
              <div class="col-6 no-padding text-right">
                <template>
                  <h5
                    v-if="!nextPeCode"
                    class="modal-title">
                    <i
                      class="fas fa-spinner spin"
                      style="font-size: 15px; position: relative; top: -1px; }"/>
                  </h5>
                  <h5
                    v-else
                    class="modal-title">
                    {{ nextPeCode }}
                  </h5>
                </template>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <template>
              <form-paymententry
                v-if="formPE_isReady"
                :prl="payslip"
                :amount="getDebtPayslipAmount(payslip)"
                :validation="trickValidationPayment"
                @submit="onSubmitPayment"
              />
            </template>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeRegisterPaymentModal()">{{ $t('button.cancel') }}</button>
            <button
              :disabled="!formPE_isReady"
              type="button"
              class="btn btn-web"
              @click="trickValidationPayment++">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
import WrapperDocRef from '@/components/combine/WrapperDocRef.vue'
import BaseSectionDocRefLink from '@/components/base/BaseSectionDocRefLink.vue'

export default {
  props: {
    payslip: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    WrapperDocRef,
    BaseSectionDocRefLink,
  },
  data () {
    return {
      loadingBtnCreatePE: false,
      trickValidationPayment: 0,
      showFormPE: false,
    }
  },
  computed: {
    ...mapGetters({
      loading: 'getLoading',
      error: 'getError',
      nextPeCode: 'getNextPeCode',
      getPaymentStatus: 'getPaymentStatus',
      getExpenseStatus: 'getExpenseStatus',
    }),
    ...mapState('payroll', {
      paySlipSingle: 'paySlipSingle',
    }),
    PELinks() {
      return this.payslip.payments.map((item) => {
        return {
          to: {
            name: 'AccountsPaymentEntryEdit',
            query: {
              pe_id: item.peId,
              pe_code: item.peCode,
            },
          },
          text: item.peCode,
          status: {
            text: this.getPaymentStatus(item, this.$t).message,
            color: this.getColorFormStatus(this.getPaymentStatus(item, this.$t).status),
            type: 'icon',
          },
          to_appid: 12,
          current_appid: 4,
        }
      })
    },
    formPE_isReady () {
      return this.showFormPE
    },
  },
  methods: {
    ...mapActions([
      'getExpense',
      'insertPayment',
      'getNextPeCode',
    ]),
    ...mapActions('payroll', {
      getPaySlipSingle: 'getPaySlipSingle',
    }),
    async openRegisterPaymentModal () {
      // set status form
      this.showFormPE = true
      // show modal
      $('#registerpaymentModal').modal('show')
      // get next pe code
      if (!this.nextPeCode) {
        await this.getNextPeCode()
        // finish bar loading
        this.showFinish(this.$Progress)
      }
    },
    closeRegisterPaymentModal () {
      // set status form
      this.showFormPE = false
      // show modal
      $('#registerpaymentModal').modal('hide')
    },
    async onSubmitPayment (isValid, data) {
      if (!isValid) {
        return false
      }

      let dataSet = {
        'type': 'pay',
        'status': data.status,
        'created_at': this.moment().toISOString(),
        'note': data.note,
        'payment': {
          	'type': data.type,
          	'amount': parseFloat(data.amount),
        },
        'reference': {
          'prl_id': this.payslip.prlId,
        },
      }

      const res = await this.$store.dispatch('insertPayment', dataSet)

      if (res.success) {
        // call api to get payslip
        await this.getPaySlipSingle(this.payslip.prlId)

        let newPayment = res.data.payment

        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: newPayment.pe_code }),
          color: 'success',
          icon: 'cloud',
        })

        // show notify completed
        if (this.paySlipSingle.process.status == 'completed') {
          let that = this
          setTimeout(() => {
            that.notify(that.$vs, {
              text: that.$t('message.hasbeencompleted', { msg: that.payslip.prlCode }),
              color: 'success',
              icon: 'check',
            })
          }, 500)
        }

        // finish loading
        this.closeRegisterPaymentModal()
        this.showFinish(this.$Progress)
      }
    },
    handleClickCreatePE() {
      this.openRegisterPaymentModal()
    },
  },
  created: async function () {

  },
  mounted: function () {
    // set popup modal
    this.setModal('#registerpaymentModal')
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/apps/payroll/payslip/include/RefPRL.vue